import { render, staticRenderFns } from "./AgencyAdmin.vue?vue&type=template&id=b7c417f0&"
import script from "./AgencyAdmin.vue?vue&type=script&lang=ts&"
export * from "./AgencyAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports